import React from 'react'
import { ActionButton } from '@emerald-works-nova/components'
import { Box, Chip, Dialog, DialogTitle, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material'
import DoNotDisturbAltIcon from '@mui/icons-material/DoNotDisturbAlt'
import { useStyles } from './style'

export function MoveCategoryModal ({
  category,
  parentCategory,
  hierarchy,
  handleMove,
  handleCategorySelection,
  newParentCategorySk,
  setNewParentCategorySk,
  open,
  onCancel
}) {
  const classes = useStyles()

  React.useEffect(() => {
    setNewParentCategorySk(null)
  }, [open, setNewParentCategorySk])

  return (
    <Dialog open={open} classes={{ paper: classes.dialogPaper }}>
      <DialogTitle id='move-category-title' className={classes.dialogTitle}>
        <Grid container className={classes.modalHeader}>
          <Typography variant='h5' data-test='category-to-move'>Move {`"${category.name}"`}</Typography>
          <Typography variant='subtitle1' data-test='category-parent'>
            Current location: <b>{parentCategory.name}</b>
          </Typography>
        </Grid>
      </DialogTitle>
      <Typography variant='subtitle1'>Select the group category to move to</Typography>
      <Box
        display='flex'
        flexDirection='column'
        mb={2}
        height='250px'
        className={classes.categoriesBox}
      >
        <RadioGroup
          value={newParentCategorySk}
          onChange={handleCategorySelection}
          data-test='group-category-selection'
        >
          {hierarchy.filter(({ sk }) => sk !== parentCategory.sk).map(({ sk, name, isVisible }) =>
            isVisible
              ? <FormControlLabel key={sk} value={sk} control={<Radio />} label={name} />
              : (
                <Box key={sk} className={classes.disabledItem}>
                  <FormControlLabel value={sk} control={<Radio />} label={name} />
                  <Chip size='small' icon={<DoNotDisturbAltIcon />} label='Disabled' className={classes.disabledIcon} />
                </Box>
              )
          )}
        </RadioGroup>
      </Box>
      <div className={classes.buttonsContainer}>
        <ActionButton
          variant='secondary'
          onClick={onCancel}
          className={classes.actionButton}
        > Cancel
        </ActionButton>
        <ActionButton
          variant='primary'
          onClick={handleMove}
          className={classes.actionButton}
          disabled={!newParentCategorySk}
        >
          Move
        </ActionButton>
      </div>
    </Dialog>
  )
}
